module.exports = __webpack_public_path__ + "img/collection-engagementRingsCharisma.43cabe6.jpg";